export default "__VITE_ASSET__Cj7FyA3N__"